import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _LineEndingMode___init__impl__jo5bul(mode) {
  return mode;
}
function _get_mode__dah3bc($this) {
  return $this;
}
function LineEndingMode__contains_impl_q5pr68($this, other) {
  return (_get_mode__dah3bc($this) | _get_mode__dah3bc(other)) === _get_mode__dah3bc($this);
}
function LineEndingMode__plus_impl_ttpz2j($this, other) {
  return _LineEndingMode___init__impl__jo5bul(_get_mode__dah3bc($this) | _get_mode__dah3bc(other));
}
function LineEndingMode__toString_impl_j4h76r($this) {
  var tmp;
  if ($this === Companion_getInstance().r4p_1) {
    tmp = 'CR';
  } else if ($this === Companion_getInstance().s4p_1) {
    tmp = 'LF';
  } else if ($this === Companion_getInstance().t4p_1) {
    tmp = 'CRLF';
  } else {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = Companion_getInstance().v4p_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.w4p_1;
      if (LineEndingMode__contains_impl_q5pr68($this, it)) {
        destination.i2(element);
      }
    }
    tmp = toString(destination);
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.r4p_1 = _LineEndingMode___init__impl__jo5bul(1);
        this.s4p_1 = _LineEndingMode___init__impl__jo5bul(2);
        this.t4p_1 = _LineEndingMode___init__impl__jo5bul(4);
        this.u4p_1 = _LineEndingMode___init__impl__jo5bul(7);
        this.v4p_1 = listOf([new (LineEndingMode())(this.r4p_1), new (LineEndingMode())(this.s4p_1), new (LineEndingMode())(this.t4p_1)]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function LineEndingMode__hashCode_impl_2mopm4($this) {
  return $this;
}
function LineEndingMode__equals_impl_qyr4nk($this, other) {
  if (!(other instanceof LineEndingMode()))
    return false;
  if (!($this === other.w4p_1))
    return false;
  return true;
}
var LineEndingModeClass;
function LineEndingMode() {
  if (LineEndingModeClass === VOID) {
    class $ {
      constructor(mode) {
        Companion_getInstance();
        this.w4p_1 = mode;
      }
      toString() {
        return LineEndingMode__toString_impl_j4h76r(this.w4p_1);
      }
      hashCode() {
        return LineEndingMode__hashCode_impl_2mopm4(this.w4p_1);
      }
      equals(other) {
        return LineEndingMode__equals_impl_qyr4nk(this.w4p_1, other);
      }
    }
    initMetadataForClass($, 'LineEndingMode');
    LineEndingModeClass = $;
  }
  return LineEndingModeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceu6i25dezdn6m,
  LineEndingMode__plus_impl_ttpz2j as LineEndingMode__plus_impl_ttpz2jpqrbpe81vmkf,
};
//endregion

//# sourceMappingURL=LineEndingMode.mjs.map
